import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { PageHero } from "@/components/shared/PageHero";
import { Eyebrow } from "@/components/shared/Eyebrow";
import { Reveal } from "@/components/shared/Reveal";
import { ContactForm } from "@/components/shared/ContactForm";
import { useSettings } from "@/hooks/useContent";
import { useSeo } from "@/components/shared/useSeo";
import { isReal } from "@/lib/display";

const HERO = "https://images.unsplash.com/photo-1698621177801-dc163e22256c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Iletisim() {
  const { data: s } = useSettings();
  useSeo({
    title: "İletişim | Sistem Elektrik ve Mühendislik",
    description: "Projeleriniz için Sistem Elektrik ve Mühendislik ile iletişime geçin.",
    canonical: "https://sistemmuhendislik.com/iletisim",
  });

  const items = [
    { icon: Phone, label: "Telefon", value: s?.company_phone, href: s?.company_phone ? `tel:${s.company_phone.replace(/[^0-9+]/g, "")}` : null },
    { icon: Mail, label: "E-posta", value: s?.company_email, href: s?.company_email ? `mailto:${s.company_email}` : null },
    { icon: MapPin, label: "Adres", value: s?.company_address },
    { icon: Clock, label: "Çalışma Saatleri", value: s?.working_hours },
  ].filter((it) => isReal(it.value));

  return (
    <>
      <PageHero
        eyebrow="İLETİŞİM"
        title="Projeniz için bizimle iletişime geçin."
        subtitle="İhtiyaçlarınızı dinleyelim, en uygun mühendislik çözümünü birlikte planlayalım."
        image={HERO}
        crumb={[{ label: "İletişim" }]}
      />

      <section className="bg-light py-24 md:py-28">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <Eyebrow className="mb-6">İLETİŞİM BİLGİLERİ</Eyebrow>
            <div className="space-y-6">
              {items.map((it) => {
                const Icon = it.icon;
                return (
                  <div key={it.label} className="flex gap-4">
                    <div className="w-11 h-11 shrink-0 flex items-center justify-center border border-ink/15 text-tech"><Icon className="w-5 h-5" strokeWidth={1.5} /></div>
                    <div>
                      <p className="text-xs uppercase tracking-wide text-ink/40">{it.label}</p>
                      {it.href
                        ? <a href={it.href} className="text-ink mt-0.5 block hover:text-tech transition-colors">{it.value}</a>
                        : <p className="text-ink mt-0.5">{it.value}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-8">
            <Reveal>
              <div className="border border-ink/10 bg-white p-6 md:p-10">
                <h2 className="font-head font-bold text-ink text-2xl mb-8">Bize Yazın</h2>
                <ContactForm />
              </div>
            </Reveal>
          </div>
        </div>

        {/* Map (only when a real embed is supplied) */}
        {s?.map_embed ? (
          <div className="mx-auto max-w-[1400px] px-5 md:px-8 mt-12">
            <div className="aspect-[21/9] w-full border border-ink/10" dangerouslySetInnerHTML={{ __html: s.map_embed }} />
          </div>
        ) : null}
      </section>
    </>
  );
}
